import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendPageView } from '@/utils/collect';

// First-party analytics beacon — fires on every route change, consent-free by
// design (server-log basis, no identifiers until consent adds a fingerprint).
const CollectBeacon = () => {
  const location = useLocation();

  useEffect(() => {
    sendPageView();
  }, [location.pathname]);

  return null;
};

export default CollectBeacon;
